import React, { Fragment, useEffect, useState } from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import styles from "./Transfer.module.scss";
import { ReactComponent as ContentCopy } from "../../assets/images/content-copy.svg";
import { useDispatch, useSelector } from "react-redux";
import { Post } from "../../api/client";
import Button from "../button/Button";
import {
  TrackOrderStatusAction,
  payOrderAction,
  trackOrderAction,
} from "../../redux/actions/orderStatus/orderStatusAction";
import PendingPaymentCard from "../PendingPaymentCard/PendingPaymentCard";
import { getMinutesLeft, setExpiryTime } from "../../utils/helpers";

type TransferProps = {
  reference: string;
};
const Transfer = ({ reference }: TransferProps) => {
  const dispatch = useDispatch();
  const [timeleft, setTimeleft] = useState<any>();
  const [accountdetails, setAccountDetails] = useState({
    recipientAccount: "",
    expirytime: null,
  });

  const [componentData, setComponentData] = React.useState<any>({
    pendingfor5min: false,
  });
  const [copied, setCopied] = useState(false);
  if (copied) {
    setTimeout(() => {
      setCopied(false);
    }, 2000);
  }

  const payload = {
    reference: reference,
    paymentOption: "BANK-TRANSFER",
    bankTransfer: {
      bankCode: "000017",
    },
  };

  const updatePendingStatus = () => {
    setComponentData({
      ...componentData,
      pendingfor5min: true,
    });
  };


  const setTimerCounter = () => {
    const timer = setExpiryTime()
    setTimeleft({ expirytime: timer });
    setInterval(() => {
      setTimeleft({ expirytime: timer })
    }, 100)
  };

  const MadePayment = () => {
    TrackOrderStatusAction(
      payload,
      dispatch,
      updatePendingStatus
    )
    dispatch(trackOrderAction({ eventname: "MADE-PAYMENT", orderReference: payload.reference }, () => { }))
  };
  useEffect(() => {
    payOrderAction(payload, dispatch, (data: any) => {
      setAccountDetails({
        ...data?.data?.paymentDetail,
      });
      setTimerCounter()
    });
  }, [reference]);

  // useEffect(() => {
  //   // setInterval(() => {
  //   //   setTimeleft({ ...timeleft });
  //   // }, 1000);
  // }, []);

  const { orderDetails } = useSelector((state) => state.orderDetailsReducer);
  const bankName = orderDetails?.data?.paymentDetails?.bankProviderName;
  const subsidiaryname = orderDetails?.data?.subsidiary?.name;

  return (
    <Fragment>
      {componentData?.pendingfor5min ? (
        <PendingPaymentCard paymentmethod="Transfer" />
      ) : (
        <>
          {accountdetails?.recipientAccount && (
            <div className={styles.transfer}>
              <div className={styles.accountNumberWrapper}>
                <p className={styles.account_label}>Account Number</p>
                <span className={styles.accountNumber}>
                  {accountdetails?.recipientAccount}
                  <CopyToClipboard
                    text={accountdetails?.recipientAccount}
                    onCopy={() => setCopied(true)}
                  >
                    <span className={styles.copy}>
                      {copied ? (
                        "Copied!"
                      ) : (
                        <>
                          copy
                          <ContentCopy />
                        </>
                      )}
                    </span>
                  </CopyToClipboard>
                </span>
              </div>
              <div className={styles.transfer_bank_details}>
                <div className={styles.bank}>
                  <p className={styles.account_label}>Bank Name</p>
                  {bankName ?? "Wema Bank"}
                </div>
                <div className={styles.bank}>
                  <p className={styles.account_label}>Beneficiary</p>
                  {subsidiaryname ?? "Payinvert Checkout"}
                </div>
              </div>
              <div className={styles.accountnumber_expiry_time}>
                Account details is valid for this transaction only and it will
                expire in {getMinutesLeft(timeleft?.expirytime)} minutes
              </div>
              <div className={styles.copy_to_clipboard}>
                <Button
                  width="100%"
                  onClick={() => MadePayment()}
                  style={{
                    color: "#ffffff",
                    width: "100%",
                    backgroundColor: "#19943c",
                  }}
                  value="I’ve sent the money"
                />
              </div>
            </div>
          )}
        </>
      )}
    </Fragment>
  );
};

export default Transfer;
